import React, { useEffect, useState } from 'react';

// import '@ant-design/compatible/assets/index.css';


import { Row, FormInstance, Spin, Input, Tabs } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { useModalState } from 'hooks/useModalState';
import { toCurrency } from 'utils/utils';
import UtinaCard from 'components/UtinaCard';
import Text from 'antd/lib/typography/Text';
import TextArea from 'antd/lib/input/TextArea';
import {
  getAssetComponentPaymentSchedule,
  getAssetsByID,
} from 'services/assets';
import { useQuery } from 'react-query';
import AssetExtraInfo from 'pages/Asset/components/AssetExtraInfo';
import GetLabel from 'DisplayFramework/components/GetLabel';
import {
  EntityAdditionalAttributeRequest,
  ViewEntityAddAttributeResponse,
} from 'services/assetconfig';
import moment from 'moment';
import { objectParValueToString, toDatePickerDate } from 'utils/utils2';
import { isBoolean, isNil, isNumber } from 'lodash';
import AssetUpload from 'components/AssetUpload';
import AssetComponents from 'pages/Asset/components/AssetComponents';
import ParListSelect from 'components/ParListSelect';
import TaxSelect from 'components/TaxSelect';
import { useAttributeContextFramework } from 'DisplayFramework/hooks/useAttribute';

const { TabPane } = Tabs;

export type TabUpdateAssetGeneralDataProps = {
  form: FormInstance;
  objectid?: number;
  dataInput?: any;
  setSuccessful?: any;
  setadditionalAttributeList?: any;
};

const TabUpdateAssetGeneralData = ({
  objectid,
  form,
  dataInput,
  setSuccessful,
  setadditionalAttributeList,
}: TabUpdateAssetGeneralDataProps) => {
  const { close: closemodal, open: openmodal, visible } = useModalState();
  const [searchParams] = useState<any>({
    objectid: objectid,
  });

  const [state, setState] = useState<any>({
    attid: 0,
    assetfamily: { value: '', label: '' },
    assettype: { value: '', label: '' },
    assetcategory: { value: '', label: '' },
  });

  const { data: attlist } = useAttributeContextFramework(
    'ASSET',
    'ASSET',
    '',
    '',
    objectParValueToString(state.assetfamily) ?? '',
    objectParValueToString(state.assettype) ?? '',
    objectParValueToString(state.assetcategory) ?? '',
    objectParValueToString(state.assetsegment) ?? '',
    objectParValueToString(state.assetmodel) ?? ''
  );
  const { data: asset, isFetching } = useQuery(
    ['getAssetsByID', { assetid: objectid }],
    () =>
      getAssetsByID({ assetid: objectid ?? 0 }).then((res) => {
        return res.data;
      }),
    { refetchOnMount: true }
  );
  const getAssetComponent = async (listComp: any) => {
    const result = listComp?.map(async (element: any) => {
      const assetCompSch = await getAssetComponentPaymentSchedule({
        compid: element.compid,
      });
      return { ...element, assetcompschedule: assetCompSch.list ?? [] };
    });
    const resultofPromises = await Promise.all(result);

    return resultofPromises;
  };
  useEffect(() => {
    setSuccessful(isFetching);
    if (asset) {
      if (!isNil(asset?.assetComponents))
        getAssetComponent(asset?.assetComponents).then((res: any) => {
          form.setFieldsValue({
            assetComponents: res?.map((comp: any) => {
              return {
                ...comp,
                supplier: {
                  tpid: comp.tpidsupplier,
                  tpname: comp.suppliername,
                  tpreference: comp.supplierreference,
                },
              };
            }),
          });
        });
    }

    if (!isNil(asset?.entityAddAttributList)) {
      let test = {};

      asset?.entityAddAttributList?.forEach(
        (att: ViewEntityAddAttributeResponse) => {
          let value: any;

          if (att.attdatatype === 'STRING') {
            value = att.attstringvalue;
          } else if (att.attdatatype === 'LONG') {
            value = att.attnumericvalue;
          } else if (att.attdatatype === 'DOUBLE') {
            value = att.attnumericvalue;
          } else if (att.attdatatype === 'BOOLEAN') {
            value = att.attbooleanvalue;
          } else if (att.attdatatype === 'TEXT') {
            value = att.atttextvalue;
          } else if (att.attdatatype === 'DATE') {
            value = moment(att.atttextvalue);
          }

          let obj = { [att.attcode]: value };
          test = { ...test, ...obj };
        }
      );

      form?.setFieldsValue({ entityAddAttributList: test });
    }

    form?.setFieldsValue({
      asset,
      assetmodel: {
        value: asset?.assetmodel ?? '',
        label: asset?.assetmodellabel ?? asset?.assetmodel ?? '',
      },
      assettaggrouping: asset?.assettaggrouping,
      assetsegment: asset?.assetsegment,
      assetcategorylabel: asset?.assetcategorylabel,
      assetfamily: {
        value: asset?.assetfamily ?? '',
        label: asset?.assetfamilylabel ?? '',
      },
      assettypelabel: asset?.assettypelabel,
      assettype: { value: asset?.assettype, label: asset?.assettypelabel },

      assetcategory: {
        value: asset?.assetcategory,
        label: asset?.assetcategorylabel,
      },

      assetconstructor: asset?.assetconstructor,
      assetdeliverydate: toDatePickerDate(asset?.assetdeliverydate),
      assetdeliveryreference: asset?.assetdeliveryreference,
      assetexpdeliverydate: toDatePickerDate(asset?.assetexpdeliverydate),
      assetdescription: asset?.assetdescription,
      assetgrossamount: asset?.assetgrossamount,
      assetid: asset?.assetid,
      assetlabel: asset?.assetlabel,
      assetpictureurl: asset?.assetpictureurl,
      assetmulticomponents: asset?.assetmulticomponents,
      assetnetamount: asset?.assetnetamount,
      taxrate: asset?.taxrate,
      taxcode: asset?.taxcode,
      assetqty: asset?.assetqty,
      assetorderdate: toDatePickerDate(asset?.assetorderdate),
      assetorderreference: asset?.assetorderreference,
      assetreference: asset?.assetreference,
      assetrisklevel: asset?.assetrisklevel,
      assetstatus: asset?.assetstatus,
      statuslabel: asset?.assetstatusdate
        ? asset?.statuslabel + ' (' + asset?.assetstatusdate + ')'
        : asset?.statuslabel,
      status: asset?.assetstatus,
      assettaxamount: asset?.assettaxamount,
      firstregistrationdate: toDatePickerDate(asset?.firstregistrationdate),
      chassisno: asset?.chassisno,
      currcode: asset?.currcode,
      deliveryadrcity: asset?.deliveryadrcity,
      deliveryadrcountry: asset?.deliveryadrcountry,
      deliveryadrregion: asset?.deliveryadrregion,
      deliveryadrstreet1: asset?.deliveryadrstreet1,
      deliveryadrstreet2: asset?.deliveryadrstreet2,
      deliveryadrzipcode: asset?.deliveryadrzipcode,
      engineno: asset?.engineno,
      fiscaldepreciationmethod: asset?.fiscaldepreciationmethod,
      flagused: asset?.flagused,
      plateno: asset?.plateno,
      power: asset?.power,
      kwhpower: asset?.kwhpower,
      kwhproduction: asset?.kwhproduction,
      kwhdegradation: asset?.kwhdegradation,
      registrationno: asset?.registrationno,
      registrationcity: asset?.registrationcity,
      registrationdate: toDatePickerDate(asset?.registrationdate),
      registrationname: asset?.registrationname,
      serialno: asset?.serialno,
      suppliername: asset?.suppliername, // internal usage only
      tpidsupplier: asset?.tpidsupplier,
      weight: asset?.weight,
      assetphase: asset?.assetphase,
      supplier: {
        tpid: asset?.tpidsupplier,
        tpreference: asset?.supplierreference,
        tpname: asset?.suppliername,
      },
      assetunitnetamount: asset?.assetunitnetamount,
      flagholdback: asset?.flagholdback,
      holdbackpercentage: asset?.holdbackpercentage ?? 0,
      holdbackamount: asset?.holdbackamount,
      holdbackbeleasedate: toDatePickerDate(asset?.holdbackbeleasedate),
      holdbackbeleasenbdays: asset?.holdbackbeleasenbdays,
      catalogid: asset?.catalogid,
      networkcode: asset?.networkcode,
      tpidbroker: {
        tpid: asset?.tpidbroker,
        tpname: asset?.brokername,
        tpreference: asset?.brokerreference,
      },
      assetfinamount: asset?.assetfinamount,
      degfeesformula: asset?.degfeesformula,
      spfeesformula: asset?.spfeesformula,
      tpofformula: asset?.tpofformula,
      age: asset?.age,
      balersize: asset?.balersize,
      separatortype: asset?.separatortype,
      wheeldrive: asset?.wheeldrive,
      transmission: asset?.transmission,
      wheeltrack: asset?.wheeltrack,
      lift: asset?.lift,
      capacity: asset?.capacity,
      tankcapacity: asset?.tankcapacity,
      nbcampaign: asset?.nbcampaign,
      threshinghours: asset?.threshinghours,
      rotorhours: asset?.rotorhours,
      totalhours: asset?.totalhours,
      totalbalers: asset?.totalbalers,
      country: asset?.country,
    });
    setState({
      attid: 0,
      assetsegment: asset?.assetsegment,
      assetfamily: {
        value: asset?.assetfamily,
        label: asset?.assetfamilylabel ?? '',
      },
      assettype: { value: asset?.assettype, label: asset?.assettypelabel },
      assetcategory: {
        value: asset?.assetcategory,
        label: asset?.assetcategorylabel,
      },
    });
  }, [asset]);

  useEffect(() => {
    let entityAddAttribut = form.getFieldValue('entityAddAttributList');
    let entityAddAttributList: EntityAdditionalAttributeRequest[] = [];

    if (entityAddAttribut !== undefined) {
      Object.keys(entityAddAttribut).forEach(function (key, index) {
        let attnumericvalue: number = 0;
        let atttextvalue: string = '';
        let attbooleanvalue = null;
        let attstringvalue: string = '';
        if (isBoolean(entityAddAttribut[key])) {
          attbooleanvalue = Boolean(entityAddAttribut[key]);
        } else if (isNumber(entityAddAttribut[key])) {
          attnumericvalue = Number(entityAddAttribut[key]);
        } else if (String(entityAddAttribut[key])?.length < 100) {
          attstringvalue = entityAddAttribut[key];
          //atttextvalue = entityAddAttribut[key];
        } else {
          atttextvalue = entityAddAttribut[key];
        }

        let attdatatype = attlist?.find(
          (attribute: any) => key === attribute.attcode
        );

        let entityAddAttributData: EntityAdditionalAttributeRequest = {
          attbooleanvalue: attbooleanvalue ?? false,
          attcode: key,
          attnumericvalue: attnumericvalue,
          attstringvalue: attstringvalue,
          atttextvalue: atttextvalue,
          entity: '',
          entityid: 0,
          id: 0,
        };

        entityAddAttributList.push(entityAddAttributData);
      });
    }
    setadditionalAttributeList(entityAddAttributList ?? []);
  }, [form.getFieldValue('entityAddAttributList')]);

  return (
    <DF.Provider
      pagcode="tabupdateassetgeneraldata"
      additionalAttribute={{
        entity: 'ASSET',
        object: 'ASSET',
        assetfamily: objectParValueToString(state.assetfamily) ?? '',
        assettype: objectParValueToString(state.assettype) ?? '',
        assetcategory: objectParValueToString(state.assetcategory) ?? '',
        assetsegment: objectParValueToString(state.assetsegment) ?? '',
        assetmodel: objectParValueToString(state.assetmodel) ?? '',
      }}
    >
      <Spin spinning={isFetching}>
        <Tabs animated defaultActiveKey="1">
          <TabPane tab={<GetLabel label="assets1" />} key={1} forceRender>
            <Row>
              <UtinaCard
                level={5}
                comcode="assetGeneralInformation"
                style={{ color: '#000' }}
                lg={11}
                additionalAttribute
              >
                <FormInput
                  col
                  lg={8}
                  name="assetreference"
                  comcode="assetreference"
                >
                  <Text>{asset?.assetreference}</Text>
                </FormInput>
                <FormInput name="statuslabel" col xs={4}>
                  <Text>{asset?.statuslabel}</Text>
                </FormInput>
                <FormInput
                  col
                  md={24}
                  name="assetlabel"
                  comcode="assetlabel"
                  rules={[{ required: true }]}
                >
                  <Input defaultValue={asset?.assetlabel}></Input>
                </FormInput>

                <FormInput name="assetsegmentlabel" col xs={10}>
                  <Text>{asset?.assetsegmentlabel}</Text>
                </FormInput>
                <FormInput name="assetfamilylabel" col xs={12}>
                  <Text>{asset?.assetfamilylabel}</Text>
                </FormInput>
                <FormInput name="assettypelabel" col xs={10}>
                  <Text>{asset?.assettypelabel}</Text>
                </FormInput>
                <FormInput name="assetcategorylabel" col xs={12}>
                  <Text>{asset?.assetcategorylabel}</Text>
                </FormInput>
                <FormInput name="assetmodellabel" col xs={10}>
                  <Text>{asset?.assetmodel}</Text>
                </FormInput>

                <FormInput col xs={24} name="assetdescription">
                  <TextArea
                    rows={3}
                    maxLength={500}
                    defaultValue={asset?.assetdescription}
                  ></TextArea>
                </FormInput>
              </UtinaCard>
              <UtinaCard
                level={5}
                lg={5}
                comcode="assetPicture"
                additionalAttribute
              >
                <FormInput col xs={24} name="assetpictureurl">
                  <AssetUpload
                    catalogid={asset?.assetid}
                    picid={1}
                    name="assetpictureurl"
                    form={form}
                    objectreference={form.getFieldValue('assetreference')}
                  />
                </FormInput>
                {/* <Image
                  preview={{ visible: false }}
                  src={UPLOAD_IMG_URL + asset?.assetpictureurl}
                  onClick={() => {}}
                /> */}
              </UtinaCard>
              <UtinaCard
                level={5}
                comcode="assetFinancialInfo"
                style={{ color: '#000', padding: 15 }}
                lg={5}
              >
                <FormInput name="currcode" col md={24}>
                  <ParListSelect parcode="CURRENCY" disabled />
                </FormInput>
                <FormInput name="assetnetamount" col md={24}>
                  <Text strong>
                    {toCurrency(
                      form?.getFieldValue('assetnetamount'),
                      form?.getFieldValue('currcode')
                    )}
                  </Text>
                </FormInput>
                <FormInput name="taxcode" col md={24}>
                  <TaxSelect
                    taxflow="INOUT"
                    onSelected={(tax) => {
                      form.setFieldsValue({
                        taxrate: tax?.taxrate ?? 0,
                      });
                    }}
                    disabled
                  />
                </FormInput>

                <FormInput col md={24} name="assettaxamount">
                  <Text strong>
                    {toCurrency(
                      form?.getFieldValue('assettaxamount'),
                      form?.getFieldValue('currcode')
                    )}
                  </Text>
                </FormInput>
                <FormInput name="assetqty" col md={24}>
                  <Text strong>{form?.getFieldValue('assetqty')}</Text>
                </FormInput>
                <FormInput col md={24} name="assetgrossamount">
                  <Text strong>
                    {toCurrency(
                      form?.getFieldValue('assetgrossamount'),
                      form?.getFieldValue('currcode')
                    )}
                  </Text>
                </FormInput>
              </UtinaCard>
            </Row>
          </TabPane>
          {asset?.assetmulticomponents && (
            <TabPane
              tab={<GetLabel label="componentInfo" />}
              key={2}
              forceRender
            >
              <AssetComponents form={form} phase="PROPOSAL" action />
            </TabPane>
          )}
          <TabPane tab={<GetLabel label="assets2" />} key={3} forceRender>
            <AssetExtraInfo form={form!!} state={state} tab></AssetExtraInfo>
          </TabPane>
        </Tabs>
      </Spin>
    </DF.Provider>
  );
};
export default TabUpdateAssetGeneralData;
